var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ico-facebook_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-5 -6.788)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 6.788)",
    clipPath: "url(#ico-facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.514 21.212h4.832v-12.1h3.372l.36-4.052h-3.732V2.752c0-.956.192-1.333 1.116-1.333h2.615v-4.205H12.73c-3.6 0-5.217 1.584-5.217 4.615V5.06H4.999v4.1h2.514z",
    fill: "#4864a8"
  }))));
}

export default SvgIcoFacebook;